import React from 'react';

import './canvasPulsePoint.scss';

export default function CanvasPulsePoint({ isPrimeStyle }) {
  return <div className={`circle ${isPrimeStyle ? 'primeStyle' : ''}`}></div>;
}
